// 🟦 Signin.jsx
// This screen lets an existing user log into the platform.

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../services/apiService";
import { useAuthStore } from "../../store/useAuthStore";
import { logger } from "../../utils/logger";
import "./auth.css";

logger.log("📂 [Signin.jsx] File started");

const SignIn = () => {
  logger.log("➡️ [SignIn] Component mounted");

  const navigate = useNavigate();
  const { setUser, setLoading, setError, error, init } = useAuthStore();
  const [form, setForm] = useState({ email: "", password: "" });

  useEffect(() => {
    logger.log("🧠 [SignIn] useEffect init()");
    init();
  }, [init]);

  const onChange = (e) => {
    logger.log("✏️ [SignIn] Updating field", { field: e.target.name });
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    logger.log("➡️ [SignIn] onSubmit start");
    setLoading(true);
    setError(null);
    try {
      const users = await api.request("/auth/users");
      const found = Array.isArray(users)
        ? users.find((u) => u.email?.toLowerCase() === form.email.toLowerCase())
        : null;

      if (!found) throw new Error("User not found. Please sign up.");

      const profile = await api.request("/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: found.uid }),
      });

      logger.log("✅ [SignIn] Login success", profile);
      setUser(profile);
      navigate("/dashboard");
    } catch (err) {
      logger.error("❌ [SignIn] Login failed", err);
      setError(err.message || "Signin failed");
    } finally {
      setLoading(false);
      logger.log("⬅️ [SignIn] onSubmit end");
    }
  };

  logger.log("✅ [SignIn] Component rendered");
  return (
    <div className="auth-wrap">
      <h1 className="auth-title">Welcome back</h1>
      <p className="auth-sub">Sign in to continue</p>

      <form onSubmit={onSubmit}>
        <div className="auth-field">
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={onChange} placeholder="you@example.com" />
        </div>
        <div className="auth-field">
          <label>Password</label>
          <input name="password" type="password" value={form.password} onChange={onChange} placeholder="••••••••" />
        </div>

        <div className="auth-actions">
          <button type="submit" className="btn-primary">Sign in</button>
        </div>
      </form>

      {error && <div className="auth-error">{error}</div>}

      <p className="auth-note" style={{ marginTop: 16 }}>
        New here? <Link to="/signup">Create an account</Link>
      </p>
    </div>
  );
};

logger.log("✅ [Signin.jsx] File executed successfully");
export default SignIn;
